import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from '../api-client-config';
import {
  AppointmentAuthorized,
  AppointmentAuthorizedCreateRequest,
  AppointmentAuthorizedCreateResponse,
  AppointmentAuthorizedDetails,
  AppointmentAuthorizedUpdateRequest,
  AppointmentAuthorizedUpdateResponse,
} from '@ms-organization-entities';
import {AuthorizedDependency, PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from "../interface/data-protection-governance-service";
import {UserResource} from "it/primatoo/openapi/api/org/schemas/userresource/UserResource";

@Injectable({
  providedIn: 'root'
})
export class AppointmentsAuthorizedService extends DataProtectionGovernanceService {

  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/appointments-authorized/';
  }

  getEndPointV1(): string {
    return this.endpoint;
  }


  setPriority(id: number, request: PriorityPatchRequest): Observable<any> {
    return undefined;
  }

  getAppointmentsAuthorized(): Observable<AppointmentAuthorized[]> {
    const url = this.endpoint;
    return this.httpClient.get<AppointmentAuthorized[]>(url);
  }

  getAppointmentsAuthorizedCandidates(): Observable<UserResource[]> {
    const url = this.endpoint + 'candidate';
    return this.httpClient.get<UserResource[]>(url);
  }

  create(appointmentAuthorizedCreateRequest: AppointmentAuthorizedCreateRequest): Observable<AppointmentAuthorizedCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<AppointmentAuthorizedCreateResponse>(url, appointmentAuthorizedCreateRequest);
  }

  createMultiple(request: { userResourceIds: number[] }): Observable<any> {
    const url = this.endpoint + 'multiple';
    return this.httpClient.post<any>(url, {userResourceIds: request.userResourceIds});
  }

  getById(appointmentId: number): Observable<AppointmentAuthorized> {
    const url = this.endpoint + `${appointmentId}/`;
    return this.httpClient.get<AppointmentAuthorized>(url);
  }

  getDetails(appointmentId: number): Observable<AppointmentAuthorizedDetails> {
    const url = this.endpoint + `${appointmentId}/details`;
    return this.httpClient.get<AppointmentAuthorizedDetails>(url);
  }

  getDependencies(appointmentId: number): Observable<AuthorizedDependency> {
    const url = this.endpoint + `${appointmentId}/dependency`;
    return this.httpClient.get<AuthorizedDependency>(url);
  }

  update(appointmentId: number, appointmentAuthorizedUpdateRequest: AppointmentAuthorizedUpdateRequest): Observable<AppointmentAuthorizedUpdateResponse> {
    const url = this.endpoint + `${appointmentId}/`;
    return this.httpClient.put<AppointmentAuthorizedUpdateResponse>(url, appointmentAuthorizedUpdateRequest);
  }
}
